import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const CropIcon = ({ color = '#fff', size = 15, ...props }) => (
  <svg
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    {...props}
  >
    <path
      fill={color}
      fillRule="nonzero"
      d="M19.81 14.9a1.11 1.11 0 0 0-.921-.49h-2.245V4.08l2.809-2.795c.027-.027.058-.056.078-.087a.556.556 0 0 0-.262-.825.55.55 0 0 0-.588.126l-2.8 2.8H5.534V1.112c0-.23-.06-.444-.18-.621A1.1 1.1 0 0 0 3.82.19a1.114 1.114 0 0 0-.51.921V3.3H1.112a1.1 1.1 0 0 0-.857.404 1.106 1.106 0 0 0 0 1.414q.033.04.071.078c.202.202.48.326.786.326h2.2v10.011c0 .228.08.44.199.615a1.12 1.12 0 0 0 .923.485h9.989v2.256a1.111 1.111 0 1 0 2.222 0v-2.256h2.245a1.111 1.111 0 0 0 .921-1.732M13.66 5.523l-8.126 8.103V5.522zM6.34 14.41l8.081-8.103v8.103z"
    />
  </svg>
);

CropIcon.propTypes = propTypes;

export default CropIcon;
